import { render, staticRenderFns } from "./downloadApk.vue?vue&type=template&id=13bf9964&scoped=true&"
import script from "./downloadApk.vue?vue&type=script&lang=js&"
export * from "./downloadApk.vue?vue&type=script&lang=js&"
import style0 from "./downloadApk.vue?vue&type=style&index=0&id=13bf9964&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13bf9964",
  null
  
)

export default component.exports